import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {State} from '../../../reducers'
import {facturacionClearAll} from '../../../actions/facturacion/facturacionEmision.actions'
import { docsAsociadosReset } from '../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../actions/forma-pago.actions'

const Encabezado = (props: any) => {
  const dispatch = useDispatch()
  const facturaEmitida = useSelector((state: State) => state.facturacion.facturaEmitda)
  const nuevaFactura = () => {
    if (facturaEmitida) {
      dispatch(facturacionClearAll())
      dispatch(handleRestartStateFormaPago())
      dispatch(docsAsociadosReset())
    } 
  }
  return (
    <>
      <div className='header-link'>
        <Link to={props.url} className='back-button w-inline-block' onClick={nuevaFactura}></Link>
        <h3 className='h3-titles xl'>Emitir factura</h3>
      </div>
      <div className='separador'></div>
    </>
  )
}

export default Encabezado
